$(document).ready(function(){
  function initZoomIfWideScreen() {
    $(".zoom-image").each(function() {
      const $img = $(this);
      if (window.innerWidth > 990) {
        if (!$img.data('ezPlus')) {
          $img.ezPlus({
            scrollZoom: false,
            zoomType: 'lens',
            lensShape: 'round',
            containLensZoom: true, 
            constrainType: "width", 
            borderSize: 0,
          });
        }
      } else {
        if ($img.data('ezPlus')) {
          $img.ezPlus('destroy');
        }
      }
    });
  }
  
  $(document).ready(initZoomIfWideScreen);
  
  $(window).on('resize', function() {
    initZoomIfWideScreen();
  });

  $('#btn--popup-otc').on('click', function (e) {
    e.preventDefault(); 
    $('#otc-popup').fadeIn();
  });
  $('.btn--readmore-collection').on('click', function (e) {
    e.preventDefault(); 
    $(this).hide();
    $('.new--banner.collection-hero--with-image .collection-hero__description').addClass('active');
  });
  $('#otc-popup .popup-close').on('click', function () {
    $('#otc-popup').fadeOut();
  });
   $('#addToCartBtn').on('click', function (e) {
    e.preventDefault();
    const mainProductId = $('input[name="id"]').val();
    const items = [{
      id: parseInt(mainProductId),
      quantity: 1,
    }];

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({ items }),
      contentType: "application/json",
      dataType: "json",
      success: function () {
          const currentUrl = window.location.pathname;
          window.location.href = currentUrl + '?open_cart=1';
      },
      error: function () {
        showPralineAlert("An error occurred while adding to cart.");
      }
    });
  });
  const params = new URLSearchParams(window.location.search);
   if (params.get('open_cart') === '1') {
     const icon = document.querySelector('#cart-icon-bubble');
    if (icon) icon.click();
    const url = new URL(window.location.href);
    url.searchParams.delete('open_cart');
    window.history.replaceState({}, document.title, url.pathname);
  }
  

  
   function setEqualHeight() {
    var maxHeight = 0;
    $('.collection-featured .swiper-wrapper .card-wrapper .description').css('height', 'auto');

    $('.collection-featured .swiper-wrapper .card-wrapper .description').each(function() {
        var currentHeight = $(this).outerHeight();
        if (currentHeight > maxHeight) {
            maxHeight = currentHeight;
        }
    });

    $('.collection-featured .swiper-wrapper .card-wrapper .description').each(function() {
        $(this).css('height', maxHeight + 'px');
    });
  }

  $(document).ready(function() {
      setEqualHeight();
  });
  
  $(window).on('resize', function() {
      setEqualHeight();
  });
  
  //click mega menu custom
  $('details.mega-menu[open]').each(function () {
    $('.header--top-center .mega-menu__list > li > a.mega-menu__link.mega-menu__link--level-2').first().addClass('active');
  });
  $('.header--top-center .mega-menu__content:not(#MegaMenu-Content-1) .mega-menu__list > li > a.mega-menu__link.mega-menu__link--level-2').first().addClass('active');
  $('.header--top-center .mega-menu__content:not(#MegaMenu-Content-1) .mega-menu__list > li > a.mega-menu__link.mega-menu__link--level-2').click(function (e) {
    e.preventDefault();
    $('.header--top-center .mega-menu__list > li > a.mega-menu__link.mega-menu__link--level-2').removeClass('active');
    $(this).addClass('active');
  });
  $('details.mega-menu').on('toggle', function () {
  if (this.open) {
    $('.mega-menu__link--level-2').removeClass('active');
    $(this)
      .find('.mega-menu__list > li > a.mega-menu__link--level-2')
      .first()
      .addClass('active');
  }
  });
  //end click mega menu custom
  
  $(".mobile-facets__sort label,.icon-topic").click(function(){
     $(this).toggleClass("active");
     $(".select").toggleClass("active");
  });
   $("div#FacetsWrapperMobile .mobile-facets__summary").click(function(){
     $(this).toggleClass("active");
  });
  
  ///// Tab Faq
  $(document).on('click','.acctab_title', function(e){
     if($(window).width() >= 768){
        $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }else{
       $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }
  });
  $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
      $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
  });
  $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
        e.preventDefault();
        $(this).toggleClass('active');
  });

  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
  });
  ///// Tab Faq

  // blog sorting
  $('.filter-blog-icon,.dropdown-title').click(function (e) { 
        e.preventDefault();
        $(this).toggleClass('active');
  });
  $("#sorting-dropdown").change(function() {
      var selectedOption = $(this).val();
      sortBlogPosts(selectedOption);
  });
  $('.blog-search').on('input', function(){
    var get_input = $(this).val().toLowerCase(); 
    var resultsCount = 0;
    $('.blog-articles__article').each(function(){
        var articleHeading = $(this).find('.card__heading a').text().toLowerCase();
        if(articleHeading.includes(get_input)){
            $(this).show();
            resultsCount++;
        }
        else{
            $(this).hide();
        }
    });
    if (resultsCount === 0) {
        $('.no-results-message').show();
    } else {
        $('.no-results-message').hide();
    }
  });

  function runSearch() {
      var get_input = $(".search-container.search-filter-block input").val().toLowerCase(); 
      var resultsCount = 0;
      $('.blog-articles__article').each(function(){
          var articleHeading = $(this).find('.card__heading a').text().toLowerCase();
          if(articleHeading.includes(get_input)){
              $(this).show();
            resultsCount++;
          } else {
              $(this).hide();
          }
      });
      $(".show_more_btn").hide();
      if (resultsCount === 0) {
        $('.no-results-message').show();
    } else {
        $('.no-results-message').hide();
    }
    }
    
    // Trigger when the search button is clicked
    $('.search-container.search-filter-block button.search-button').on('click', function() {
      runSearch();
    });
    
    // Trigger when Enter is pressed inside the input field
    $(".search-container.search-filter-block input").on('keypress', function(e) {
      if (e.which === 13) { // 13 is the Enter key code
        runSearch();
      }
    });
  
  function sortBlogPosts(option) {
    var postsContainer = $(".blog-articles");
    var posts = postsContainer.children(".cust_sort_blog");
  
    switch (option) {
      case "title-ascending":
        posts.sort(function(a, b) {
          return $(a).find(".blog-post-title").text().localeCompare($(b).find(".blog-post-title").text());
        });
        break;
      case "title-descending":
        posts.sort(function(a, b) {
          return $(b).find(".blog-post-title").text().localeCompare($(a).find(".blog-post-title").text());
        });
        break;
      case "created-ascending":
        posts.sort(function(a, b) {
          var dateA = new Date($(a).find(".blog-post-date").text());
          var dateB = new Date($(b).find(".blog-post-date").text());
          return dateA - dateB;
        });
        break;
      case "created-descending":
        posts.sort(function(a, b) {
          var dateA = new Date($(a).find(".blog-post-date").text());
          var dateB = new Date($(b).find(".blog-post-date").text());
          return dateB - dateA;
        });
        break;
      default:
        // No sorting, maintain original order
        break;
    }
    postsContainer.empty().append(posts);
  }
    const $loadMoreButton = $('[data-pagination-btn]');
    if ($loadMoreButton.length) {
          const $productGrid = $('.blog-articles');
        $loadMoreButton.on('click', function(e) {
            e.preventDefault();
            const nextUrl = $loadMoreButton.attr('href');

            $loadMoreButton.text("Laden...");
            $loadMoreButton.prop('disabled', true);

            $.get(nextUrl, function(response) {
                const $tempDiv = $('<div>').html(response);
                const newProductsHtml = $tempDiv.find('.blog-articles').html();

                $productGrid.append(newProductsHtml);

           

                const $newButton = $tempDiv.find('[data-pagination-btn]');
                const newHref = $newButton.attr('href');

                if ($newButton.length && newHref && newHref !== nextUrl) {
                    $loadMoreButton.attr('href', newHref);
                    $loadMoreButton.text("MEHR ANZEIGEN");
                    $loadMoreButton.prop('disabled', false);
                } else {
                    $loadMoreButton.text("Keine Produkte mehr").hide(); 
                }
            }).fail(function() {
                console.error('Error loading more products.');
                $loadMoreButton.text("Try again");
                $loadMoreButton.prop('disabled', false);
            });
        });
    }

});


